import { render } from "./PaymentProvidersView.vue?vue&type=template&id=af196296&scoped=true&ts=true"
import script from "./PaymentProvidersView.vue?vue&type=script&lang=ts"
export * from "./PaymentProvidersView.vue?vue&type=script&lang=ts"

import "./PaymentProvidersView.vue?vue&type=style&index=0&id=af196296&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af196296"]])

export default __exports__